/**
 * Terranis processing chain type
 */
enum ProcessingType {
    IRRIGATION = "irrigation",
    VEGETATION = "vegetation",
    NITROGEN = "nitrogen",
    VISIOCROP = "visiocrop",
}

export default ProcessingType;
